export const ocrQualityMessages = {
  'zh-CN': {
    attributeEnhancement: '属性栏 · 浅底黑字',
    preprocessRejected: '框选区域不符合当前识别来源，尚未送入 OCR。请框选完整数值，属性栏旁的标签需保持可见。',
    worldsLevelPreprocessRejected: '未能确认完整的底栏等级，尚未送入 OCR。请框选完整等级数字并保留少量边距；若包含 LV.，请保持标签完整。',
    lowConfidence: '上次读到“{text}”，置信度 {confidence}，未达到 {minimumConfidence}。',
    failed: '上次等级读取未采用：{reason}。',
    retrying: '正在重试，请保持游戏画面可见。',
    minimumConfidence: '等级确认门槛',
    attempt: '等级尝试 {index}',
  },
  en: {
    attributeEnhancement: 'Attributes · dark text on light background',
    preprocessRejected: 'This selection does not match the recognition source and was not sent to OCR. Select the complete value and keep its Attributes label visible.',
    worldsLevelPreprocessRejected: 'The complete HUD level could not be confirmed and was not sent to OCR. Select all level digits with a small margin. If LV. is included, keep the entire label visible.',
    lowConfidence: 'Last read “{text}” at {confidence} confidence; at least {minimumConfidence} is required.',
    failed: 'The last level reading was rejected: {reason}.',
    retrying: 'Retrying. Keep the game visible.',
    minimumConfidence: 'Level confidence threshold',
    attempt: 'Level attempt {index}',
  },
}
